import script from "./PortalOtpLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalOtpLogin.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__